import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "filters",
  id: "filter-tab-external-content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "control-label d-block" }, "Filter by:", -1 /* HOISTED */)
const _hoisted_3 = { class: "dropdown-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All countries", -1 /* HOISTED */)
const _hoisted_5 = ["value"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All states", -1 /* HOISTED */)
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All airports", -1 /* HOISTED */)
const _hoisted_10 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCountry) = $event)),
          id: "locationsSelectedCountry",
          class: "form-control form-select",
          onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.updateSelectedCountry()))
        }, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
            return (_openBlock(), _createElementBlock("option", {
              value: country.code
            }, _toDisplayString(country.name), 9 /* TEXT, PROPS */, _hoisted_5))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelSelect, _ctx.selectedCountry]
        ])
      ]),
      (_ctx.selectedCountry == 'USA')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedState) = $event)),
              id: "locationsSelectedState",
              class: "form-control form-select",
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($options.updateFilters()))
            }, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: state.code
                }, _toDisplayString(state.name), 9 /* TEXT, PROPS */, _hoisted_8))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, _ctx.selectedState]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedAirport) = $event)),
          id: "locationsSelectedAirport",
          class: "form-control form-select",
          onChange: _cache[5] || (_cache[5] = ($event: any) => ($options.updateSelectedAirport()))
        }, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.airports, (airport) => {
            return (_openBlock(), _createElementBlock("option", {
              value: airport.code
            }, _toDisplayString(airport.code), 9 /* TEXT, PROPS */, _hoisted_10))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelSelect, _ctx.selectedAirport]
        ])
      ])
    ])
  ]))
}